import React, {useEffect, useState} from 'react'
import {Col, Form, Modal, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'
import {SkeletonInput} from 'src/components'
import {KTSVG} from 'src/_metronic/helpers'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import dateformat from 'src/utils/dateformat'
import swal from 'sweetalert'
import { fetchHistorySIP } from 'src/services/fetcher'
import axios from 'axios'

interface PropsItem {
  id: any,
  show: boolean,
  onCloseModal(): void
}

export const SIPHistories: React.FC<PropsItem> = (props) => {
    const {t} = useTranslation()
    const [historiesSIP, setHistoriesSIP] = useState<any>({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (props.id) {
            setLoading(true)
            fetchHistorySIP(props.id, {is_amandment: true})
                .then((res: any) => {
                    setHistoriesSIP(res.data.data)
                })
                .catch((err) => {
                    swal({
                    closeOnClickOutside: false,
                    title: t(err.response.data.message),
                    icon: 'error',
                    })
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [props.id])

    const handleCheckFile = (url: any) => {
        axios
          .get(url)
          .then((response: any) => {
            window.open(url)
          })
          .catch((error: any) => {
            swal({
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
      }

    const convertToRoman = (num: number): string => {
        const romanNumerals: { [key: string]: number } = {
            M: 1000,
            CM: 900,
            D: 500,
            CD: 400,
            C: 100,
            XC: 90,
            L: 50,
            XL: 40,
            X: 10,
            IX: 9,
            V: 5,
            IV: 4,
            I: 1,
        };
    
        let roman = '';
        for (let key in romanNumerals) {
            const value = romanNumerals[key];
            while (num >= value) {
                roman += key;
                num -= value;
            }
        }
    
        return roman;
    }

    const getDescription = (sip: any) : string => {
        if (sip?.amendment_counting) {
            if (sip?.sip_type == 'SI002') {
                return `Ke-${convertToRoman(sip?.amendment_counting)}`
            } else {
                return `Revisi ${convertToRoman(sip?.amendment_counting)}`
            }
        } else return '-'
    }

    return (
        <div>
            <Modal
                size='lg'
                show={props.show}
                onHide={props.onCloseModal}
                backdrop='static'
                keyboard={false}
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t('history-sip-amendment')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div>
                            <SkeletonInput />
                        </div>
                    ) : (
                        <div>
                        <Row>
                            <Col md={12}>
                                <Row className='mb-3'>
                                    <Col className='d-flex align-items-center' md={4}>
                                    <p className='fs-4'>
                                        {t('sip-number-2')}
                                    </p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control type='text' defaultValue={'11' + historiesSIP?.SIP_number} disabled size='sm' />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('Regarding SIP')}</p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control
                                        type='text'
                                        defaultValue={historiesSIP?.sip_type_desc}
                                        disabled
                                        size='sm'
                                    />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('Description')}</p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control
                                        type='text'
                                        defaultValue={getDescription(historiesSIP)}
                                        disabled
                                        size='sm'
                                    />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control
                                        type='text'
                                        value={(historiesSIP?.customer?.title ? `${historiesSIP?.customer?.title} ` : '') + historiesSIP?.customer?.name}
                                        placeholder={t('Customer Name')}
                                        disabled
                                        size='sm'
                                    />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('Sales Org')}</p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control
                                        type='text'
                                        value={historiesSIP?.anper?.name}
                                        placeholder={t('Sales Org')}
                                        disabled
                                        size='sm'
                                    />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('order-tanggal')}</p>
                                    </Col>
                                    <Col md={8}>
                                    <Form.Control
                                        type='text'
                                        placeholder={t('order-tanggal')}
                                        defaultValue={dateformat(historiesSIP?.created_at)}
                                        disabled
                                        size='sm'
                                    />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={4}>
                                    <p className='fs-4 mt-2'>{t('Download File')}</p>
                                    </Col>
                                    <Col md={8}>
                                        <button
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('unduh sip')}
                                            onClick={() => {
                                                handleCheckFile(
                                                (historiesSIP.document != null
                                                    ? historiesSIP.document?.file_path +
                                                    `&token=${localStorage.getItem('token')}`
                                                    : historiesSIP.file_path) +
                                                    `?token=${localStorage.getItem('token')}`
                                                )
                                            }}
                                            >
                                            <KTSVG
                                                path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                                                className='svg-icon-3'
                                            />
                                        </button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <div className='table-responsive mt-5 bdr' style={{maxHeight: '300px'}}>
                            <table className='table table-row-gray-300 align-middle gs-0 gy-4'>
                                <thead className='border-bottom'>
                                    <tr className='fw-bold jusify-content-center w-100 align-items-center'>
                                        <th className='text-center'>{t('No')}</th>
                                        <th className='td-order-4 text-center'>{t('Regarding SIP')}</th>
                                        <th className='td-order-1 text-center'>{t('Description')}</th>
                                        <th className='td-order-2 text-center'>{t('order-tanggal')}</th>
                                        <th className='text-center'>{t('kontrak-aksi')}</th>
                                    </tr>
                                </thead>
                                {historiesSIP.history_sip_amendment && (
                                    <tbody>
                                        {historiesSIP.history_sip_amendment?.map((item: any, index: number) => {
                                            return (
                                                <tr
                                                    key={index + 1}
                                                    className='jusify-content-center w-100 align-items-center'
                                                >
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td className='td-order-4'>{item?.sip_type_desc}</td>
                                                    <td className='td-order-1 text-center'>{getDescription(item)}</td>
                                                    <td className='td-order-2 text-center'>{dateformat(item.created_at)}</td>
                                                    <td className='text-center'>
                                                        <button
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                            data-bs-toggle='tooltip'
                                                            data-bs-placement='top'
                                                            data-bs-trigger='hover'
                                                            title={t('unduh sip')}
                                                            onClick={() => {
                                                                handleCheckFile(
                                                                (item.document != null
                                                                    ? item.document?.file_path +
                                                                    `&token=${localStorage.getItem('token')}`
                                                                    : item.file_path) +
                                                                    `?token=${localStorage.getItem('token')}`
                                                                )
                                                            }}
                                                            >
                                                            <KTSVG
                                                                path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                                                                className='svg-icon-3'
                                                            />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )})
                                        }
                                    </tbody>
                                )}
                            </table>
                        </div>
                        </div>  
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}